import React from "react";
import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 28 }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children, className = "", light = false }) => (
  <span
    className={`section-overline text-xs font-bold uppercase ${
      light ? "text-camel" : "text-camel"
    } ${className}`}
  >
    {children}
  </span>
);

export const SectionHeading = ({ overline, title, subtitle, light = false }) => (
  <div className="max-w-3xl">
    {overline && (
      <Reveal>
        <Overline light={light}>{overline}</Overline>
      </Reveal>
    )}
    <Reveal delay={0.05}>
      <h2
        className={`mt-5 font-display font-semibold text-4xl sm:text-5xl lg:text-6xl tracking-tight ${
          light ? "text-linen" : "text-espresso"
        }`}
      >
        {title}
      </h2>
    </Reveal>
    {subtitle && (
      <Reveal delay={0.1}>
        <p
          className={`mt-6 text-base sm:text-lg font-light leading-relaxed ${
            light ? "text-linen/70" : "text-espresso/65"
          }`}
        >
          {subtitle}
        </p>
      </Reveal>
    )}
  </div>
);
